import dealer from '@/api/administrator/dealer-profile'
import commission from '@/api/accounting/default-commission'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return dealer.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return dealer.store(data)
  },
  update(context, { id, data }) {
    return dealer.update(id, data)
  },
  destroy(context, { id, data }) {
    return dealer.destroy(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await dealer.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  dealerType(context) {
    return dealer.dealerType()
  },
  parentDealer(context) {
    return dealer.get({
      params: {
        filter: {
          dealer_type_id: 1 // only supper dealer
        },
        fields: {
          dealer_profiles: 'dealer_id,dealer_name'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  commissionRate(context, dealer_id) {
    return commission.get({
      params: {
        filter: {
          dealer_type_id: dealer_id // only supper dealer
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  download(context, options) {
    return dealer.download({
      params: options
    })
  }
}
